import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { whatWeDoService } from '../services/whatWeDoService';

const WhatWeDo = () => {
  const [pageContent, setPageContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const content = await whatWeDoService.getWhatWeDoContent();
        setPageContent(content);
      } catch (err) {
        setError("Failed to load content.");
        console.error("Error fetching What We Do content:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return <div className="text-center py-20">Loading...</div>;
  }

  if (error) {
    return <div className="text-center py-20 text-red-500">{error}</div>;
  }
  
  const heroSection = pageContent?.sections.find(s => s.id === 'hero');
  const servicesSection = pageContent?.sections.find(s => s.id === 'services');

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-display font-bold text-text-primary mb-4">{heroSection?.heading}</h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {servicesSection?.items?.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              <div
                className="w-12 h-12 mx-auto bg-accent/10 rounded-full flex items-center justify-center text-accent mb-4"
                dangerouslySetInnerHTML={{ __html: service.icon }}
              />
              <h3 className="text-lg font-semibold text-text-primary mb-2">{service.title}</h3>
              <p className="text-sm text-text-secondary">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;